<template>
  <div class="card" @click="handleToDetail">
    <div class="flag_badge" v-if="item.readCount<=0"></div>
    <div class="img"
         :style="{ backgroundImage: item && item.pictureUrl ? `url(${item.pictureUrl})` : `url(${require('@/assets/img_message.png')})` }">
    </div>
    <div class="title">
      <div class="content">
        <div class="tag" style="display: inline-flex;">
          <!--          <el-button v-if="item.type===3" size="small" type="danger">{{ $t('common.cds40') }}</el-button>-->
          <template v-if="item.isTop!==1">
            <el-button v-if="item.consultType===1" size="small" type="info">{{ $t('common.cds37') }}</el-button>
            <el-button v-else-if="item.consultType===2" size="small" type="info">{{ $t('common.cds36') }}</el-button>
            <el-button v-else-if="item.consultType===3" size="small" type="info">{{ $t('common.cds38') }}</el-button>
          </template>
          <template v-else>
            <el-button size="small" type="danger">{{ $t('common.cds40') }}</el-button>
          </template>
        </div>
        {{ item.title }}
      </div>
    </div>
    <div class="time">{{ item.sendTime || item.createTime }}</div>
  </div>
</template>


<script setup>
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed} from "vue";

const {item} = defineProps({
  item: {
    type: Object,
    default: () => {
    }
  }
})

const router = useRouter()
const store = useStore()
const notifyList = computed(() => store.state.message.notifyList)
const handleToDetail = async () => {
  // 更新 阅读状态
  await store.dispatch("message/updateReadCountApis", {id: item.id})
  const targetResult = notifyList.value.map(it => {
    if (it.id === item.id) {
      return {...it, readCount: it.readCount + 1}
    } else {
      return {...it}
    }
  })
  await store.commit("message/setNotifyList", targetResult)
  await queryNoticeListApisUnReadApi()
  // 获取列表
  openNewTab('/messageDetail', {id: item.id})
}
const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};


const queryNoticeListApisUnReadApi = async () => {
  const payload = {
    pageNo: 1,
    pageSize: 1,
    type: 3,
  }
  await store.dispatch("message/queryNoticeListApisUnRead", payload)
}

</script>


<style lang="less" scoped>
.card {
  position: relative;
  cursor: pointer;
  width: 343px;
  height: 268px;
  background: white;
  padding: 16px;
  border-radius: 5px;

  .flag_badge {
    position: absolute;
    width: 15px;
    height: 15px;
    background: #f56c6c;
    border: 2px solid white;
    right: -4px;
    top: -4px;
    border-radius: 50%;
    z-index: 999;
  }

  .img {
    width: 100%;
    height: 160px;
    background-color: #ffffff; /* 背景色保留 */
    border-radius: 5px;
    background-size: cover; /* 关键：缩放并填满容器 */
    background-position: center center; /* 关键：显示图片中间 */
    background-repeat: no-repeat; /* 不重复 */
    overflow: hidden; /* 防止子元素溢出 */
    text-align: center; /* 如果有文字，可以居中 */
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #444444;

    .content {
      min-height: 45px !important;
      height: auto; /* 不建议固定高度 */
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 限制显示 2 行 */
      -webkit-box-orient: vertical;
    }
  }

  .time {
    text-align: right;
    margin-top: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}

:deep(.el-button) {
  min-width: 40px;
  width: max-content !important;
  height: 20px;
  line-height: 20px
}
</style>